const STORAGE_KEY = 'sisa_order_configuration';

const VALID_VARIANTS = ['basic', 'extended'];
const VALID_DURATIONS = [6, 12];
const VALID_CANCELLATION = [500, 1000, 1500];

export const DEFAULT_ORDER_CONFIGURATION = {
  product_variant: 'basic',
  duration_in_months: 12,
  trip_cancellation_coverage: 500,
};

export function saveOrderConfiguration(config) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify({
      product_variant: config.product_variant,
      duration_in_months: config.duration_in_months,
      trip_cancellation_coverage: config.trip_cancellation_coverage,
    }));
  } catch (e) {
    // ignore quota / private mode
  }
}

export function loadOrderConfiguration() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch (e) {
    return null;
  }
}

export function isValidOrderConfiguration(config) {
  if (!config || typeof config !== 'object') return false;
  if (!VALID_VARIANTS.includes(config.product_variant)) return false;
  if (!VALID_DURATIONS.includes(Number(config.duration_in_months))) return false;
  const coverage = config.trip_cancellation_coverage;
  if (coverage != null && !VALID_CANCELLATION.includes(Number(coverage))) return false;
  return true;
}

export function calculateOrderPrice(config) {
  if (!isValidOrderConfiguration(config)) return null;
  const prices = {
    extended: { 6: 124, 12: 203 },
    basic: { 6: 78, 12: 132 },
  };
  const pauseAdditions = { 500: 18, 1000: 36, 1500: 54 };
  const duration = Number(config.duration_in_months);
  const base = prices[config.product_variant][duration];
  const coverage = config.trip_cancellation_coverage;
  if (coverage) {
    return base + (pauseAdditions[Number(coverage)] || 0);
  }
  return base;
}
